export interface AppConfig {
  API_BASE_URL: string;
  API_TOKEN: string;
}

const DEFAULT_API_BASE_URL = "/api";

export function getConfig(): AppConfig {
  const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || DEFAULT_API_BASE_URL;
  const API_TOKEN = import.meta.env.VITE_API_TOKEN || "";

  if (!API_TOKEN && import.meta.env.DEV) {
    console.warn(
      "VITE_API_TOKEN is empty. POST endpoints requiring auth will fail. " +
      "Copy .env.example to .env.local and fill in the values.",
    );
  }

  return { API_BASE_URL, API_TOKEN };
}
